import script from "./RdSkeleton.vue?vue&type=script&lang=ts"
export * from "./RdSkeleton.vue?vue&type=script&lang=ts"

import "./RdSkeleton.vue?vue&type=style&index=0&id=cc8ba860&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc8ba860"]])

export default __exports__